define('views/savings/saving_create_btn',[
    'views/_base/baseview',
    'text!views/savings/saving_create_btn.html',
    'views/savings/create',
    'views/shared/modal/modal_modern'
], function (BaseView, Template, CreateSavingsView, Modal){
    'use strict';

    return BaseView.extend({
        className: 'saving saving-create-new-container',
        tagName : 'li',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click': 'createSavings',

        },
        initialize: function(options){
            options = options || {};

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            return this;
        },

        createSavings: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            if(pf.IsConsumerFinancial){

                var create_savings_modal_view = new CreateSavingsView();
                    
                var savings_create_modal = new Modal({
                    show        : true,
                    content     : create_savings_modal_view.$el.html(),
                    calling_view: create_savings_modal_view
                });

            } else {
                goToFinancialRegistration('savings');
            }
            
            
        },

        close: function () {}
    });
});

